import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { PPUAlertService } from '@app/shared/services/ppu-alert.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-view-pdf-dialog',
  templateUrl: './view-pdf-dialog.component.html',
  standalone: false,
})
export class ViewPdfDialogComponent {
  pdfUrl!: SafeResourceUrl;

  constructor(
    private dialogRef: MatDialogRef<ViewPdfDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { pdfContent?: string; pdfUrl?: string },
    private sanitizer: DomSanitizer,
    private alertService: PPUAlertService,
    private translateService: TranslateService
  ) {
    if (!!this.data.pdfUrl) {
      this.pdfUrl = this.data.pdfUrl;
    } else if (!!this.data.pdfContent) {
      this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.data.pdfContent);
    }else{
      this.alertService.errorEvent(this.translateService.instant('App.ViewPdf.Messages.NoPdfAvailable'));
      this.closePdfViewer();
    }
  }

  closePdfViewer() {
    this.dialogRef.close();
  }
}
